module.exports = __webpack_public_path__ + "img/Ventuar_Spiked Hammer.264f0ff0.png";